export const calculationMethodValues = {
  AS_DESIGNED: 'AS_DESIGNED',
  USER_DEFINED: 'USER_DEFINED',
  DNV_ST_N001: 'DNV_ST_N001'
}

export const calculationMethods = [
  { id: 'AS_DESIGNED', value: calculationMethodValues.AS_DESIGNED, mandatory: true },
  { id: 'USER_DEFINED', value: calculationMethodValues.USER_DEFINED, mandatory: true },
  { id: 'DNV_ST_N001', value: calculationMethodValues.DNV_ST_N001, mandatory: false }
]
